// How the app is being used, for the business dashboards (TF-127): the kind of device and the app's
// language, sent with the company list that opening the app asks for. The tenant service counts them
// per company and day as numbers; nothing ties them to a person.

export type DeviceClass = 'phone' | 'tablet' | 'computer';

/** Material's window size classes (TF-93): compact below 600 pixels, medium below 840, expanded from there. */
export function deviceClass(width: number): DeviceClass {
  if (width < 600) return 'phone';
  if (width < 840) return 'tablet';
  return 'computer';
}

export function usageHeaders(): Record<string, string> {
  return { 'x-device-class': deviceClass(window.innerWidth), 'x-app-language': document.documentElement.lang || 'en' };
}
